import { render, staticRenderFns } from "./BoxComponent.vue?vue&type=template&id=7ad827d4&"
import script from "./BoxComponent.vue?vue&type=script&lang=js&"
export * from "./BoxComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports